import { Injectable } from "@angular/core";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "src/app/global/global";
import { BehaviorSubject, Observable, ReplaySubject } from "rxjs";
import { HttpParams } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class InventoryServiceService {

  private invetoryForm: any;

  public setInventoryData(data) {
    this.invetoryForm = data;
    console.log(this.invetoryForm, 'invetoryForm');
    
  }

  public getInventoryData() {
    return this.invetoryForm;
  }
  constructor() {
   
   }
   
}
